import React, { useEffect, useContext, useState } from "react";
import { MapConfig } from "./pages/map/mapconfig";
import Header from "./layout/header/header";
import {
  getContributionOptions,
  getDensityCoverage,
  getDistrictData,
  getIQOSData,
  getLeftDemographicsData,
  getLocationsData,
  getMetaData,
  getPerformanceCardData,
  getRegionData,
  getRegions,
  getRightDemographicsData,
  getTempGeojson,
  getTouchpoints
} from "./apiconfig";
import Sidebar from "./layout/sidebar/sidebar";
import { ApiContext } from "./context/apicontext";

// set sidebar and API calls
export default function App() {
  const { setBenchmarkData,setFilterData, setDensityData, setPerformanceData, setLeftDemographicsData,setRightDemographicsData,setIQOsData,setLocationData,setRegionData,setDistrictData,setTempGeojsonData} = useContext(ApiContext);
  const [loading, setLoading] = useState(true);

  // All API Call
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        const [contributionOptions, touchpointsData, densityCoverage, performanceCardData, leftdemographicsData,locationData,regionJson,districtJSON,rightdemographicsData,IQOSdata,tempGeojsonData] = await Promise.all([
          getContributionOptions(),
          getTouchpoints(),
          getDensityCoverage(),
          getPerformanceCardData(),
          getLeftDemographicsData(),
          getLocationsData(),
          getRegionData(),
          getDistrictData(),
          getRightDemographicsData(),
          getIQOSData(),
          // getMetaData(),
          // getRegions(),
          getTempGeojson()
        ]);

        setBenchmarkData(contributionOptions);
        setFilterData(touchpointsData);
        setDensityData(densityCoverage);
        setPerformanceData(performanceCardData);
        setLeftDemographicsData(leftdemographicsData);
        setLocationData(locationData);
        setRegionData(regionJson);
        setDistrictData(districtJSON);
        setRightDemographicsData(rightdemographicsData);
        setIQOsData(IQOSdata);
        setTempGeojsonData(tempGeojsonData);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [setBenchmarkData, setDensityData, setPerformanceData, setLeftDemographicsData, setFilterData, setLocationData, setRegionData,setDistrictData,setRightDemographicsData]);

  return (
    <>
      <div className="main-header">
        <Header />
      </div>
      {loading ? (
        <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : (
        <div className="main-content">
          <div className="main-sidebar">
              <Sidebar />
          </div>
          <div className="main-map">
            <MapConfig />
          </div>
        </div>
      )}
    </>
  );
}